/** The Bolt Circles mark (same shape as public/icons/icon.svg), colored by the theme tokens. */
export function LogoMark({ size = 40, className }: { size?: number; className?: string }) {
  return (
    <svg width={size} height={size} viewBox="0 0 512 512" className={className} aria-hidden>
      <rect width="512" height="512" rx="114" fill="var(--accent)" />
      <circle cx="256" cy="256" r="132" fill="none" stroke="var(--accent-ink)" strokeWidth="30" />
      <circle cx="256" cy="124" r="40" fill="var(--accent-ink)" />
      <circle cx="370.3" cy="322" r="40" fill="var(--accent-ink)" />
      <circle cx="141.7" cy="322" r="40" fill="var(--accent-ink)" />
    </svg>
  );
}
